/* eslint-disable no-template-curly-in-string */
/**
 * @file 编辑器扩展, 增加自定义组件
 */
import { BasePlugin, registerEditorPlugin } from 'amis-editor'

export class InfoGridPlugin extends BasePlugin {
  // 关联渲染器名字
  rendererName = 'chamformula';
  $schema = '/schemas/UnkownSchema.json';
  notRenderFormZone = true;
  // 组件名称（组件面板显示的Title）
  name = '公式编辑器';
  order = 0; // 排序
  description = '公式编辑器';
  tags = ['A自定义'];
  icon = 'fa fa-file-code-o';
  // 插入到页面时需要
  scaffold = {
    'type': 'service',
    'body': [
      {
        'type': 'each',
        'name': 'sxList',
        'items': {
          'type': 'container',
          'body': [
            {
              'type': 'button',
              'label': '${label}',
              'onEvent': {},
              'id': 'u:c8b8805efb1c',
              'disabledOnAction': false
            }
          ],
          'size': 'none',
          'style': {
            'position': 'static',
            'display': 'block',
            'flex': '0 0 auto'
          },
          'wrapperBody': false,
          'isFixedHeight': false,
          'themeCss': {
            'baseControlClassName': {
              'boxShadow:default': ' 0px 0px 8px 0px rgba(3, 3, 3, 0.1)',
              'radius:default': {
                'top-left-border-radius': 'var(--borders-radius-3)',
                'top-right-border-radius': 'var(--borders-radius-3)',
                'bottom-left-border-radius': 'var(--borders-radius-3)',
                'bottom-right-border-radius': 'var(--borders-radius-3)'
              },
              'padding-and-margin:default': {
                'marginRight': '10px',
                'marginBottom': '10px'
              }
            }
          },
          'id': 'u:497cbe230cc7',
          'onEvent': {
            'click': {
              'weight': 0,
              'actions': [
                {
                  'componentId': 'u:99162ac32330',
                  'ignoreError': false,
                  'actionType': 'setValue',
                  'args': {
                    'value': {
                      'textNR': "${JOIN([textNR,'${'+value+'}'])}"
                    }
                  }
                }
              ]
            }
          }
        },
        'placeholder': '',
        'style': {
          'position': 'static',
          'display': 'flex',
          'flexWrap': 'wrap',
          'justifyContent': 'flex-start',
          'alignItems': 'center',
          'marginTop': '10px',
          'marginBottom': '10px'
        },
        'isFixedHeight': false,
        'isFixedWidth': false,
        'size': 'none',
        'id': 'u:360283c78c25'
      },
      {
        'type': 'container',
        'body': [
          {
            'type': 'ae-textareaFormulaControl',
            'id': 'u:441f81155e0d',
            'name': 'textNR',
            'label': '',
            'required': true,
            'variableMode': 'tab',
            'mode': 'normal',
            'inline': false,
            'validationErrors': {},
            'validations': {},
            'formula': false,
            'variables': '${sxList2}',
            'functions': [],
            'description': '',
            'placeholder': '',
            'visibleOn': '${sxList2}',
            'className': 'w-full'
          }
        ],
        'style': {
          'position': 'relative',
          'display': 'flex',
          'inset': 'auto',
          'flexWrap': 'nowrap',
          'flexDirection': 'row',
          'alignItems': 'flex-start'
        },
        'size': 'none',
        'wrapperBody': false,
        'id': 'u:14d607a37190',
        'isFixedHeight': false,
        'isFixedWidth': false,
        'wrapperCustomStyle': {
          '.cm-expression-text': {
            'max-width': '500px'
          }
        }
      }
    ],
    'id': 'u:eb7862d21be0',
    'dsType': 'api',
    'api': {
      'url': '/device/getDeviceAttr?devIds=${checkboxes}',
      'method': 'get',
      'requestAdaptor': '',
      'adaptor': "payload.forEach(item => {\r\n  item[\"tag\"] = \"属性\"\r\n})\r\n\r\nresponse.data= {\r\n  sxList: payload,\r\n  sxList2: [\r\n    {\r\n      label:'设备属性',\r\n      children:payload\r\n    }\r\n  ]\r\n}\r\nreturn response",
      'messages': {},
      'data': {
        'devIds': '${checkboxes}'
      },
      'sendOn': 'this.checkboxes'
    }
  };
  // 组件面板预览时需要
  previewSchema = {
    'type': 'service',
    'body': [
      {
        'type': 'each',
        'name': 'sxList',
        'items': {
          'type': 'container',
          'body': [
            {
              'type': 'button',
              'label': '${label}',
              'onEvent': {},
              'id': 'u:c8b8805efb1c',
              'disabledOnAction': false
            }
          ],
          'size': 'none',
          'style': {
            'position': 'static',
            'display': 'block',
            'flex': '0 0 auto'
          },
          'wrapperBody': false,
          'isFixedHeight': false,
          'themeCss': {
            'baseControlClassName': {
              'boxShadow:default': ' 0px 0px 8px 0px rgba(3, 3, 3, 0.1)',
              'radius:default': {
                'top-left-border-radius': 'var(--borders-radius-3)',
                'top-right-border-radius': 'var(--borders-radius-3)',
                'bottom-left-border-radius': 'var(--borders-radius-3)',
                'bottom-right-border-radius': 'var(--borders-radius-3)'
              },
              'padding-and-margin:default': {
                'marginRight': '10px',
                'marginBottom': '10px'
              }
            }
          },
          'id': 'u:497cbe230cc7',
          'onEvent': {
            'click': {
              'weight': 0,
              'actions': [
                {
                  'componentId': 'u:99162ac32330',
                  'ignoreError': false,
                  'actionType': 'setValue',
                  'args': {
                    'value': {
                      'textNR': "${JOIN([textNR,'${'+value+'}'])}"
                    }
                  }
                }
              ]
            }
          }
        },
        'placeholder': '',
        'style': {
          'position': 'static',
          'display': 'flex',
          'flexWrap': 'wrap',
          'justifyContent': 'flex-start',
          'alignItems': 'center',
          'marginTop': '10px',
          'marginBottom': '10px'
        },
        'isFixedHeight': false,
        'isFixedWidth': false,
        'size': 'none',
        'id': 'u:360283c78c25'
      },
      {
        'type': 'container',
        'body': [
          {
            'type': 'ae-textareaFormulaControl',
            'id': 'u:441f81155e0d',
            'name': 'textNR',
            'label': '',
            'required': true,
            'variableMode': 'tab',
            'mode': 'normal',
            'inline': false,
            'validationErrors': {},
            'validations': {},
            'formula': false,
            'variables': '${sxList2}',
            'functions': [],
            'description': '',
            'placeholder': '',
            'visibleOn': '${sxList2}',
            'className': 'w-full'
          }
        ],
        'style': {
          'position': 'relative',
          'display': 'flex',
          'inset': 'auto',
          'flexWrap': 'nowrap',
          'flexDirection': 'row',
          'alignItems': 'flex-start'
        },
        'size': 'none',
        'wrapperBody': false,
        'id': 'u:14d607a37190',
        'isFixedHeight': false,
        'isFixedWidth': false,
        'wrapperCustomStyle': {
          '.cm-expression-text': {
            'max-width': '500px'
          }
        }
      }
    ],
    'id': 'u:eb7862d21be0',
    'dsType': 'api',
    'api': {
      'url': '/device/getDeviceAttr?devIds=${checkboxes}',
      'method': 'get',
      'requestAdaptor': '',
      'adaptor': "payload.forEach(item => {\r\n  item[\"tag\"] = \"属性\"\r\n})\r\n\r\nresponse.data= {\r\n  sxList: payload,\r\n  sxList2: [\r\n    {\r\n      label:'设备属性',\r\n      children:payload\r\n    }\r\n  ]\r\n}\r\nreturn response",
      'messages': {},
      'data': {
        'devIds': '${checkboxes}'
      },
      'sendOn': 'this.checkboxes'
    }
  };

  // 容器类组件必需字段
  // regions = [
  //   {
  //     key: 'body',
  //     label: '内容区'
  //   }
  // ];

  panelTitle = '配置'; // 右侧属性面板Title

  panelControls = [ // 右侧属性面板配置项

  ];
}

registerEditorPlugin(InfoGridPlugin)
